import React from 'react';
import { Moon, Sun } from 'lucide-react';

// Split auth layout: brand panel (always navy) + form panel (themed).
export function AuthShell({ theme, children }) {
  return (
    <div className="km-auth">
      <aside className="km-auth-brand">
        <div className="km-auth-logo"><img src="/brand/mark.svg" width="40" height="40" alt="KryptaMail" /><span>krypta<b>mail</b></span></div>
        <div className="km-auth-hero">
          <span className="km-auth-eyebrow">Post-quantum mail &amp; collaboration server</span>
          <h1>Email that outlives the quantum era.</h1>
          <p>Mail, calendar, contacts and tasks on your own server, secured with NIST post-quantum cryptography in transit, end to end and at rest.</p>
        </div>
        <div className="km-auth-facts">
          <div><b>Hybrid PQC TLS</b><span>X25519 + ML-KEM on every endpoint</span></div>
          <div><b>PQC end-to-end</b><span>Even the server cannot read mail</span></div>
          <div><b>On-prem or SaaS</b><span>Your cluster, our cloud, or hardware</span></div>
          <div><b>Flexible licensing</b><span>One-time, subscription or bundle</span></div>
        </div>
      </aside>
      <main className="km-auth-main">
        <button type="button" className="km-auth-theme" title={theme.isDark ? 'Switch to light' : 'Switch to dark'} onClick={theme.toggle}>{theme.isDark ? <Sun size={16} /> : <Moon size={16} />}</button>
        {children}
      </main>
    </div>
  );
}

export function AuthHeading({ title, sub }) {
  return <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}><span style={{ fontSize: 26, fontWeight: 600, letterSpacing: '-.02em' }}>{title}</span>{sub && <span className="km-muted" style={{ fontSize: 14, lineHeight: 1.5 }}>{sub}</span>}</div>;
}
